import React, { useEffect } from 'react';
import { useFiscalMonthSettingsStore } from '../stores/fiscalMonthSettingsStore';
import { useCurrencySettingsStore } from '../stores/currencySettingsStore';
import { useUserStore } from '../stores/useUserStore';

/**
 * Component that loads global settings when the user is authenticated.
 * This ensures that settings like fiscal month and currency are available
 * throughout the app, even if the user hasn't visited the settings page yet.
 */
export const GlobalSettingsLoader: React.FC = () => {
  const { user } = useUserStore();
  const { loadSettings: loadFiscalSettings, hasLoadedFromAPI: hasLoadedFiscal } = useFiscalMonthSettingsStore();
  const { loadSettings: loadCurrencySettings, hasLoadedFromAPI: hasLoadedCurrency } = useCurrencySettingsStore();

  useEffect(() => {
    if (user) {
      // Load fiscal month settings if not loaded
      if (!hasLoadedFiscal) {
        console.log('GlobalSettingsLoader: Loading fiscal month settings');
        loadFiscalSettings();
      }
      
      // Load currency settings if not loaded
      if (!hasLoadedCurrency) {
        console.log('GlobalSettingsLoader: Loading currency settings');
        loadCurrencySettings();
      }
    }
  }, [user, hasLoadedFiscal, hasLoadedCurrency, loadFiscalSettings, loadCurrencySettings]);

  return null; // This component doesn't render anything
};
